import { makeStyles } from "@material-ui/core/styles";

export const footerStyles = makeStyles((theme) => ({
  footer: () => ({
    height: "48px",
    padding: "10px 25px 10px 0px",
    backgroundColor: "#fafafa",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    borderTop: "1px solid #E6E6E6",
    width: "100%",
    "& a": {
      marginRight: "40px",
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "space-evenly",
    },
    "& .MuiListItem-root": {
      width: "auto",
      fontFamily: "Lato",
      padding: "5px",
      "& span": {
        fontSize: theme.typography.pxToRem(14),
      },
    },
  }),
}));
